import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import HelloAppH5Page from '../hello-app-h5/common/HelloAppH5Page';
import { HelloBuyerAppH5Config } from '../hello-buyer-app-h5/HelloBuyerAppH5Config';
import { BuyerAppDeepLinkConfig, BuyerAppDeepLinkKind } from './BuyerAppDeepLinkConfig';

type BuyerAppDeepLinkRouteParams = {
  productId?: string;
  sellerId?: string;
};

const BuyerAppDeepLinkPage: React.FC<{ kind: BuyerAppDeepLinkKind }> = ({ kind }) => {
  const { productId, sellerId } = useParams<BuyerAppDeepLinkRouteParams>();
  const id = (kind === 'product' ? productId : sellerId)?.trim() ?? '';
  if (!id) {
    return <Navigate to="/helloBuyerAppH5" replace />;
  }

  const copy = BuyerAppDeepLinkConfig[kind];

  return (
    <HelloAppH5Page
      role="buyer"
      documentTitle={copy.documentTitle}
      shareButtonLabel={copy.shareButtonLabel}
      downloadButtonLabel={HelloBuyerAppH5Config.downloadButtonLabel}
      iosAppStoreUrl={HelloBuyerAppH5Config.iosAppStoreUrl}
      androidApkUrl={HelloBuyerAppH5Config.androidApkUrl}
      appOpenPathSuffix={`${kind}/${id}`}
      sharePrimaryDownloadsOnly
      backgroundImageUrl={`${process.env.PUBLIC_URL}/h5bg/buyer.png`}
      placeholderBackgroundColor="#12B362"
      buttonBackgroundColor="#ffffff"
      buttonTextColor="#1a1a1a"
    />
  );
};

export default BuyerAppDeepLinkPage;
